import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Layout } from './components/Layout';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import InfluencerMarketingPage from './pages/InfluencerMarketingPage';
import AIUGCAdsPage from './pages/AIUGCAdsPage';
import RealUGCPage from './pages/RealUGCPage';
import SocialMediaContentPage from './pages/SocialMediaContentPage';
import AboutPage from './pages/AboutPage';
import BlogPage from './pages/BlogPage';
import BlogPost1 from './pages/BlogPost1';
import BlogPost2 from './pages/BlogPost2';
import BlogPost3 from './pages/BlogPost3';
import ContactPage from './pages/ContactPage';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/influencer-marketing" element={<InfluencerMarketingPage />} />
              <Route path="/services/ai-ugc-ads" element={<AIUGCAdsPage />} />
              <Route path="/services/real-ugc" element={<RealUGCPage />} />
              <Route path="/services/social-media-content" element={<SocialMediaContentPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/nano-influencer-marketing" element={<BlogPost1 />} />
              <Route path="/blog/ai-ugc-guide" element={<BlogPost2 />} />
              <Route path="/blog/employer-branding-2026" element={<BlogPost3 />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
          </Layout>
        </BrowserRouter>
        <div className="noise-overlay" />
      </div>
    </HelmetProvider>
  );
}

export default App;
